import { Route, Routes } from 'react-router-dom';

import { Test } from './components/Test/Test';
import { Release } from './components/Release/Release';

const TestAndReleaseView = () => {
  return (
    <Routes>
      <Route path="/" element={<Test />} />
      <Route path="/test" index element={<Test />} />
      <Route path="/release" element={<Release />} />
    </Routes>
  );
};

export default TestAndReleaseView;
